<form class="lv-artefact-container lv-component"
      [ngClass]="!!uiArtefakt?.Ausrichtung ? uiArtefakt?.Ausrichtung : uiAusrichtung">
  <div class="lv-artefact" [ngClass]="uiArtefakt.BreiteInPixel">
    <lv-label-tooltip [label]="uiArtefakt.Text" [labelSymbol]="nestedSymbol"
                      [tooltip]="uiArtefakt.InfoTextTooltipCollapsable"
                      [isPflichtfeld]="uiArtefakt.PflichtfeldJN"
                      [isCollapsable]="uiArtefakt.InfoTextTooltipCollapsableTyp === 'Collapsable'"
                      (infotextCollapsableChange)="infotextCollapsableChange($event)"></lv-label-tooltip>
    <lv-info-text-tooltip-collapsable [showInfotext]="showInfotextCollapsable"
                                      [tooltip]="uiArtefakt.InfoTextTooltipCollapsable"></lv-info-text-tooltip-collapsable>
    <mat-form-field class="lv-material-form-input" color="accent">
      <div class="lv-input-field"
           [ngClass]="{'lv-input-field-error': getError()}">
        <mat-select [(ngModel)]="value" [hideSingleSelectionIndicator]="true"
                    [name]="uiArtefakt.Identifikator"
                    [required]="uiArtefakt.PflichtfeldJN"
                    [compareWith]="compareObjects"
                    [disabled]="isDisabled"
                    [errorStateMatcher]="stateMatcherFormInput"
                    #lvdropdown="ngModel"
                    (blur)="onBlur()"
                    (valueChange)="setAntwortDropdown($event)">
          <mat-select-trigger>
            <span>{{uiArtefakt.WertAnzeige}}</span>
          </mat-select-trigger>
          <mat-option *ngFor="let dropdownItem of loadedOptions$ | async" [value]="dropdownItem"
                      class="lv-mat-option-multiline">
            {{dropdownItem.WertAnzeige}}
            <div *ngFor="let synonym of dropdownItem.synonyme" class="lv-synonym-option">
              {{synonym}}
            </div>
          </mat-option>
        </mat-select>
      </div>
      <mat-error class="lv-control-error" *ngIf="getError() as error"
                 [ngClass]="{'lv-show-untruncated-error': showUntruncatedError}"
                 (click)="onErrorClick()">
        {{error}}
      </mat-error>
    </mat-form-field>
    <lv-infotext-permanent
        [InfoTextPermanent]="uiArtefakt.InfoTextPermanent"></lv-infotext-permanent>
  </div>
</form>
